import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import Icon from '~/Common-Objects/UI/Icon'
import Icons from '~/Common-Objects/UI/Icons/index'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import i18n from '~/i18n'
import copy from 'copy-to-clipboard';
import { alterSnackbar } from "~/data/actions/siteActions";
import TwoColPaperExplainer from '~/Common-Objects/DomainManagement/Components/TwoColPaperExplainer'

export default function SPFDKIMSettings({ domainId, domain, setFlowStep, domainProvider, domainRecords, setDomainRecords, subDomain = "" }) {
    const site = useSelector((state) => state.siteMaster)
    const dispatch = useDispatch();
    const copyVal = (val) => {
        copy(val);
        dispatch(alterSnackbar(true, "Copied to clipboard"));
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            setFlowStep("dmarcSettings");
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    let exists = false;

    const newRecordsData = domainRecords.filter(record => record.type == "SPFDKIM").map(record => {
        let finalValue = record.value;
        if (record.value.indexOf("v=spf") > -1) {
            if (domain.spfExists) {
                exists = true;
                finalValue = domain.spfExists;
                let ourFinalValue = record.value.split(" ")[1];
                let includeCount = record.value.split("include:").length - 1;
                if(includeCount > 1) {
                    ourFinalValue += " " + record.value.split(" ")[2];
                }
                let finalValueSplit = finalValue.split(" ");
                finalValueSplit.splice(-1, 0, ourFinalValue);
                finalValue = finalValueSplit.join(" ");
            }
        }

        let finalHost = record.host;
        if (subDomain) {
            if(finalHost == "@")
            {
                finalHost = subDomain;
            }
            else
            {
                finalHost = finalHost + "." + subDomain;
            }
        }
        
        return {
            type: {
                headerValue: 'Type',
                value: <SquareChip>{record.recordType}</SquareChip>
            },
            host: {
                headerValue: 'Host',
                value: <TextInput readOnly={true} value={finalHost} iconRight={<Icon name="copy" onClick={() => { copyVal(finalHost) }} />} />
            },
            value: {
                headerValue: 'Value/Target',
                value: <TextInput readOnly={true} value={finalValue} iconRight={<Icon name="copy" onClick={() => { copyVal(finalValue) }} />} />
            }
        }
    })

    return (
        <>
            <div>{i18n.t('company:domains.domainManagement.addRecords', { provider: domainProvider?.label })}</div>
            
            {exists && <TwoColPaperExplainer
                className="mar-t20 mar-b5 paper-purple-light"
                title={i18n.t('company:domains.domainManagement.spfAlreadyExists')}
                content={i18n.t('company:domains.domainManagement.spfAlreadyExistsContent')}
                icon={<Icons icon="info" style={{ width: "20px", height: "20px" }} />}
            />}


            <DataTable1
                tableData={newRecordsData}
                loadingData={[]}
                dataUpdater={() => { }}
                width='100%'
                pageSize='100'
                hasCheckBoxes='no'
                sortedColumn={""}
                sortedDirection={""}
                className='mar-b20'
            />

            <Button
                text={i18n.t('company:domains.domainManagement.continue')}
                iconRight={<Icons icon="arrowRight" />}
                className="button-primary"
                onClick={() => {
                    setFlowStep("dmarcSettings");
                }}
            />

            <TwoColPaperExplainer
                className="mar-t20 mar-b5"
                title={i18n.t('company:domains.domainManagement.spfDkimExplainerTitle')}
                content={i18n.t('company:domains.domainManagement.spfDkimExplainerContent')}
            />

        </>



    )
}